import { render, staticRenderFns } from "./IadeArizaOnayMail.vue?vue&type=template&id=5120634c&"
import script from "./IadeArizaOnayMail.vue?vue&type=script&lang=js&"
export * from "./IadeArizaOnayMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports